/*
 * Copyright (c) Worldline 2022.
 */

import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {SignatureDto} from "../../model/signatureDto";
import {SignerDto} from "../../model/signerDto";
import {FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {HandSignDto} from "../../model/handSignDto";
import {NgSignaturePadOptions, WlHandSignComponent} from "../wl-hand-sign/wl-hand-sign.component";
import {NgxSpinnerService} from "ngx-spinner";
import {HttpService} from "../../http/http.service";
import {CustomErrors} from "../../constant/custom-errors";
import {ConsentGroupDto} from "../../model/consentGroupDto";
import {AgreementsOptions} from "../../constant/agreements-options";
import {DomSanitizer} from "@angular/platform-browser";
import {ActivatedRoute, Router} from "@angular/router";
import {SharedService} from "../../services/shared.service";
import {SignerService} from "../../services/signer.service";
import {SessionService} from "../../services/session.service";
import {RedirectionService} from "../../services/redirection.service";
import {HttpClient} from "@angular/common/http";
import {RootScopeService} from "../../services/rootscope.service";
import ExternalSignatureStatusEnum = SignatureDto.ExternalSignatureStatusEnum;
import ActionEnum = SignatureDto.ActionEnum;

@Component({
    selector: 'app-smartphone-agreement',
    templateUrl: './smartphone-agreement.component.html'
})
export class SmartphoneAgreementComponent implements OnInit, AfterViewInit {


    currentSignature: SignatureDto | any;
    signatures: SignatureDto[] = [];
    trueSignatures: SignatureDto[] = [];
    currentSigner: SignerDto;
    containsTrueSignatures: boolean = false;
    formConsentsValidation: FormGroup;
    consents: any;
    submitted: boolean = false;
    alreadyConsented: boolean = false;
    controlDocumentCompleteReading: boolean = false;
    documentFullyRead = false;

    onHoldAvailability: boolean = false;
    onHoldLimitReached: boolean = false;

    sessionId: any;
    errorMsg: any;
    submit: any;
    otpErrorMsg: any;

    areMultipleDocuments: boolean = false;
    currentSignaturePosition!: number;

    @ViewChild('mobile_landscape')
    public mobileLandscape!: ElementRef;

    @ViewChild('signature')
    public signaturePad!: WlHandSignComponent;

    //init hand signature dimensions here:
    handSignOptions: NgSignaturePadOptions = {canvasHeight: 150, canvasWidth: 500};
    private shortId!: string;

    constructor(private redirectionService: RedirectionService,
                private sessionService: SessionService,
                private signersService: SignerService,
                private router: Router,
                private route: ActivatedRoute,
                private sanitizer: DomSanitizer,
                private formBuilder: FormBuilder,
                private shared: SharedService,
                private spinner: NgxSpinnerService,
                public http: HttpService,
                private httpClient: HttpClient,
                private rootScope: RootScopeService) {
        this.currentSigner = signersService.currentSigner;
        this.formConsentsValidation = this.formBuilder.group({});
    }

    ngOnInit(): void {
        const that = this;
        console.debug("Init smartphone")
        sessionStorage.setItem('sessionType', 'smartphone');
        // Check the sessionId
        this.shortId = this.route.snapshot.params['shortId'];
        //load session
        if (!sessionStorage.getItem('shortId')) {
            this.httpClient.get('/config/front').toPromise().then(function saveConfig(response: any) {
                that.rootScope.get().properties = response;
                that.loadSession();
            });
        } else {
            this.sessionId = sessionStorage.getItem("sessionId");
            if (!this.signersService?.currentSigner?.extSignerId) {
                this.redirectionService.sessionWithParams(this.route.snapshot.params, this.sessionId)
            }
            this.getSignatures();
        }
    }

    ngAfterViewInit(): void {
        console.debug("after view init smartphone")
        let that = this;
        window.addEventListener('onorientationchange' in window ? 'orientationchange' : 'resize', function () {
            if (window.orientation === 180 || window.orientation === 0 || window.orientation === 90 || window.orientation === -90) {
                that.landscape();
            }
        }, false);

        this.landscape();
    }

    signerName(): string {
        if (this.currentSigner) {
            return this.currentSigner.firstName + ' ' + this.currentSigner.lastName;
        } else {
            return '';
        }
    }


    //if portrait,display alert
    landscape() {
        console.info('orientation = ' + window.orientation);
        if (window.orientation === 180 || window.orientation === 0) {
            this.mobileLandscape.nativeElement.style.display = 'block';

        } else {
            this.mobileLandscape.nativeElement.style.display = 'none';
        }
    }

    loadSession() {
        let that = this;
        console.info('start loading session ...');

        var token = 'short-id:' + this.shortId;
        console.debug('Putting token in session storage: ', token);
        sessionStorage.setItem('token', token);

        this.http.loadShortIdSession(this.shortId).toPromise().then(function (response) {
            if (response?.success) {
                console.info('Session loaded successfully');
                that.sessionId = response.result;
                console.info('sessionId:' + that.sessionId);
                sessionStorage.setItem('shortId', that.shortId);
                sessionStorage.setItem('sessionId', that.sessionId);
                that.redirectionService.session(that.route, that.sessionId);
            } else {
                console.info('load session Failed');
                console.warn(response?.error?.msg);
                that.exitError();
            }
        });
    }

    signatureIsDone(signature: any) {
        return [ExternalSignatureStatusEnum.Agreed, ExternalSignatureStatusEnum.Successful].indexOf(signature.externalSignatureStatus) !== -1;

    }

    formReset() {
        this.submitted = false;
    }


    //submit hand signature
    private handSign() {
        let that = this;
        console.debug('submitting hand signature');
        // Build object for request


        let body: HandSignDto = {
            points: that.signaturePad.toData(),
            width: that.handSignOptions.canvasWidth,
            height: that.handSignOptions.canvasHeight,
        };

        return that.http.handSignAgreement(that.sessionId, that.signersService.currentSigner.extSignerId, that.currentSignature?.documentDto?.extDocumentId, body).toPromise().then(function (response) {
            if (response?.success) {
                console.info('Sign smartphone successful');
                that.submitted = true;

                that.signaturePad.clear();
                that.currentSignature.externalSignatureStatus = ExternalSignatureStatusEnum.Successful;

                that.getSignatures();
            } else {
                that.signatureError();
            }
            that.spinner.hide('spinner-bottom');
        }, that.signatureError);
    }

    signatureError() {
        console.log('signature error');
        this.submitted = false;
    }

    // Get all signatures from the API
    getSignatures() {
        let that = this;
        console.debug('Getting all the signatures');
        console.debug(this.signersService);
        return this.http.getAllSignatures(this.sessionId, this.signersService.currentSigner.extSignerId).toPromise().then(function (response) {

            if (response?.success) {
                // If no error
                console.info('get all signature success ', response.result);
                if ((response.result as SignatureDto[]).length > 0) {
                    // Attach signatures into the scope
                    that.signatures = response.result as SignatureDto[];
                    console.info('Signature got successfully, signature status is: ', that.signatures[0].externalSignatureStatus);

                    // specify true signatures from approvals
                    that.specifyActions();

                    // Select a current signature
                    that.chooseSignature();

                    that.areMultipleDocuments = that.signatures.length > 1;

                    if (that.currentSignature) {
                        // Reset the variables (for successive calls of getSignatures)
                        that.submit = undefined;
                        that.errorMsg = undefined;
                        that.consents = undefined;

                        if (!that.alreadyConsented) {
                            console.debug("already consent")
                            that.getConsents();
                        } else {
                            that.handSign();
                        }
                    } else {
                        if (that.currentSignature === null) {
                            // There is a signature in error state
                            console.debug('There is a signature in error state');
                            that.exitError();
                        } else {
                            console.debug('All signatures are done');
                            // that.router.navigateByUrl("/session/" + that.sessionService.id)
                            // TODO clear cookie
                            let params = {
                                pId: 'smartphone',
                                locale: that.route.snapshot.params['locale'],
                                sessionId: that.route.snapshot.params['sessionId']
                            }
                            that.redirectionService.sessionWithParams(params, that.sessionService.id);
                        }
                    }
                } else {
                    // not normal because there is at least one document to sign
                    console.warn('There is no signature');
                }

            } else {
                // If process error
                // Log the error and redirect
                console.warn(response?.error?.msg);
                that.exitError();
            }

        }, that.exitError);
    }

    sendConsents() {
        console.debug('sending consents');
        let obj: any[] = [];
        this.consents.forEach(function (consent) {
            consent.consentTextDtoList.forEach(function (consentText) {
                console.info('consent : ', consentText);
                obj.push(consentText.status);
            });
        });
        return this.http.updateAllConsents(this.sessionId, this.signersService.currentSigner.extSignerId, this.currentSignature.documentDto.extDocumentId, obj).toPromise();
    }

    submitSignature() {
        let that = this;
        if (!this.isSubmitButtonDisabled()) {
            this.spinner.show('spinner');
            var list, index;
            list = document.getElementsByClassName('submitConsent');
            for (index = 0; index < list.length; ++index) {
                list[index].setAttribute("disabled", true);
            }

            console.debug('submitting smartphone hand-signature ...');
            this.submitted = true;

            let promise;

            if (this.consents && this.consents.length > 0 && !this.alreadyConsented) {
                promise = this.sendConsents().then(function (response) {
                    try {

                        if (response?.success) {
                            console.debug('consents sent : success');
                            that.currentSignature.externalSignatureStatus = ExternalSignatureStatusEnum.Consented;
                            that.alreadyConsented = true;
                            return that.handSign();
                        } else {
                            console.warn('An error occurred when sending the consents');
                            console.warn(response?.error?.msg);
                            that.otpErrorMsg = 'error.consents.send';
                            that.redirectionService.error(that.route, CustomErrors.invalidSession, that.sessionId);
                            return Promise.reject('failed');
                        }
                    } finally {
                        that.spinner.hide('spinner-bottom');
                    }

                }).catch(() => {
                    that.signatureError();
                });
            } else {
                promise = that.handSign();
            }
            promise.then(function () {
                //reset to not display consent mandatory error
                that.submitted = false;

                var list, index;
                list = document.getElementsByClassName('submitConsent');
                for (index = 0; index < list.length; ++index) {
                    list[index].setAttribute("disabled", false);
                }

                // angular.element('.submitConsent').prop('disabled', false);
            }).catch(() => {
                that.signatureError();
            });
        }

    }

    getConsents(): any {
        let that = this;
        console.debug('Getting consents');

        if (!this.currentSignature) {
            console.debug('Can\'t get consents because there is no chosen signature');
            this.consents = undefined;
            return;
        }

        this.alreadyConsented = false;
        //else test signature status
        if (this.currentSignature.externalSignatureStatus === ExternalSignatureStatusEnum.Consented) {
            this.alreadyConsented = true;
        }

        return this.http.getAllConsents(that.sessionId, that.signersService.currentSigner.extSignerId, that.currentSignature.documentDto.extDocumentId).toPromise().then(function (response) {

            // Disable the spin
            that.spinner.hide('spinner');

            if (response?.success) {
                // If no error

                if ((response.result as ConsentGroupDto[]).length > 0) {
                    that.consents = [];

                    (response.result as ConsentGroupDto[]).forEach(function (consent) {

                        if (AgreementsOptions.authorizedWebConsentsTypes.indexOf(consent.type!) !== -1) {

                            consent.consentTextDtoList?.forEach(function (consentText) {
                                that.formConsentsValidation.addControl('consent-' + consent.rank + '_text-' + consentText.status?.rank, new FormControl());
                            })

                            that.consents.push(that.buildConsentLink(consent));
                        } else {
                            console.debug('A consent group is not displayed : rank =', consent.rank);
                            console.debug('A consent group is not displayed : type =', consent.type);
                        }
                    });
                } else {
                    console.debug('There is no consent for this signature.');
                }

            } else {
                // If process error
                // Log the error and redirect
                console.warn(response?.error?.msg);
                that.exitError();
            }

        }, that.exitError);
    }

    buildConsentLink(consentGroup: any): any {
        let that = this;
        consentGroup.consentTextDtoList.forEach(function (consentText) {

            if (consentText.mandatory) {
                consentText.text = consentText.text + ' *';
            }

            if (consentText.link) {
                //this is a consentLink
                var link = consentText.link;
                var regexp = /([^\[]*)(\[.*])([^\[]*)/g;
                var result = regexp.exec(consentText.text);
                var pre, linkText, post;
                if (result) {
                    pre = result[1];
                    linkText = result[2];
                    //remove '[' and ']'
                    linkText = linkText.substring(1, linkText.length - 1);
                    post = result[3];
                }
                //rebuild text with link
                var text = pre;
                text += '<a href="';
                text += link;
                text += '"  target="_blank" class="consentLink" >';
                text += linkText;
                text += '</a>';
                text += post;

                consentText.text = that.sanitizer.bypassSecurityTrustHtml(text);
            } else {
                consentText.text = that.sanitizer.bypassSecurityTrustHtml(consentText.text);
            }
        });

        return consentGroup;
    }

    specifyActions() {
        console.debug('Specify signatures actions');
        this.trueSignatures = [];

        for (var i = 0, j = this.signatures.length; i < j; i++) {
            var signature = this.signatures[i];
            if (signature.action === ActionEnum.Signature) {
                this.trueSignatures.push(signature);
                this.containsTrueSignatures = true;
            }
        }
    }

    chooseSignature() {
        let that = this;
        console.debug('Choosing signature');
        if (!this.signatures) {
            console.debug('Can\'t choose a signature because there are no signatures into the scope');
            this.currentSignature = undefined;
            return;
        }

        this.currentSignature = undefined;
        console.info('nbr of signatures: ' + this.signatures.length);
        this.signatures.forEach(function (signature, index) {
            if (!that.currentSignature) {
                console.info('Choosing signature --- signature status: ' + signature.externalSignatureStatus);
                switch (signature.externalSignatureStatus) {
                    case ExternalSignatureStatusEnum.Init:
                    case ExternalSignatureStatusEnum.Consented:
                        that.currentSignaturePosition = index + 1;
                        that.currentSignature = signature;
                        return;
                    case ExternalSignatureStatusEnum.ErrTech:
                    case ExternalSignatureStatusEnum.ErrBusiness:
                        console.debug('signature in error : ', signature.externalSignatureStatus);
                        that.currentSignature = null;
                        return;
                    case ExternalSignatureStatusEnum.Agreed:
                    case ExternalSignatureStatusEnum.Successful:
                        // Go to the next
                        break;
                    default:
                        // Log the error and redirect
                        console.warn('invalid externalSignatureStatus : ' + signature.externalSignatureStatus);
                        that.currentSignature = null;
                        return;
                }
            }
        });
    }

    hold() {
        let that = this;

        console.debug('Hold the session');
        // Enable spin
        this.spinner.show('spinner');

        this.http.hold(this.sessionId, this.signersService.currentSigner.extSignerId).toPromise()
            .then(function (response) {

                //Disable the spin
                that.spinner.hide('spinner');

                if (response?.success) {
                    console.debug('Hold the session : SUCCESS');
                    var urlOnHold = that.sessionService.info.urlOnHold;
                    if (urlOnHold) {
                        that.redirectionService.exit(that.sessionService.getUrlOnHold());
                    } else {
                        that.redirectionService.hold(that.route, that.sessionId);
                    }

                } else {
                    //Log the error and redirect
                    console.warn(response?.error);
                    that.errorMsg = 'error.unexpected';
                }
            }, that.exitError);
    }

    exitError() {
        this.redirectionService.error(this.route, CustomErrors.unreachableService, this.sessionId);
    }

    isSubmitButtonDisabled() {
        return (this.controlDocumentCompleteReading && !this.documentFullyRead) || !this.formConsentsValidation.valid || this.submitted;

    }


}
